module.exports = __webpack_public_path__ + "static/img/message.fb7cf122.png";